// load external libraries
import $ from 'jquery';
window.jQuery = $;
import csv from 'jquery-csv';
window.csv = csv;
import '../bootstrap.js';
import 'linkify-string';
import tinymceContentUiCss from 'tinymce/skins/ui/oxide/content.css?inline';
import tinymceContentCss from 'tinymce/skins/content/default/content.css?inline';

let _App = (function () {

    let routeCallbacks = {},
        routeCallbacksRegex = [];

    function _initRoute ( route ) {
        if (!route) return;

        if (routeCallbacks[route]) {
            $.each(routeCallbacks[route], function ( i, callback ) {
                callback();
            });
        }

        $.each(routeCallbacksRegex, function ( i, data ) {
            if (data.regex.test(route)) data.callback();
        });
    }

    function _evalTpl ( tpl, obj ) {
        var t = tpl,
            val;
        for (var k in obj) {
            val = obj[k];
            if (val === null) {
                val = '';
            }
            if (obj.hasOwnProperty(k)) {
                t = t.replace(new RegExp('{{' + k + '}}', 'g'), val);
            }
        }
        return t;
    }

    /**
     *
     * @param type = [error, success]
     * @param title
     * @param msg
     * @private
     */
    function _toastNotification ( type = 'error', title = null, msg = null ) {
        let elToast = $('#toast_error_notification');

        elToast.toast('hide');

        if (type === 'error') {
            elToast.find('.toast-title').removeClass('text-success').addClass('text-danger');
        } else {
            elToast.find('.toast-title').removeClass('text-danger').addClass('text-success');
        }

        elToast.find('.toast-title').html('{{title}}');
        elToast.find('.toast-body').html('{{body}}');
        let tpl = _evalTpl(elToast.html(), {
            'title': title ?? 'Error',
            'body': msg ?? 'Something unexpected happened. Please try again or reload the page.'
        });

        elToast.html(tpl);
        setTimeout(function () {
            elToast.toast('show');
        }, 500)
    }

    function _confirmationModal ( msg, callback ) {
        let elConfirm = $('#alertConfirmModal');

        elConfirm.find('.modal-body').html('{{body}}');
        let tpl = _evalTpl(elConfirm.find('.modal-body').html(), {
            'body': msg
        });

        elConfirm.find('.modal-body').html(tpl);

        elConfirm.modal('show');

        elConfirm.on('click', '.btn.confirm', function () {
            elConfirm.modal('hide');
            $(this).off('click');
            callback(true);
        });

        elConfirm.on('hidden.bs.modal', function () {
            elConfirm.modal('hide');
            callback(false);
        });
    }

    function _confirmRemove ( e ) {
        e.preventDefault();
        let el = $(this),
            target = el.attr('href'),
            msg = el.data('msg');

        _confirmationModal(msg, function ( resp ) {
            if (resp) $(target)[0].submit();
        });

    }

    function _typeDelay ( callback, ms ) {
        let timer = 0;
        return function () {
            let context = this, args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function () {
                callback.apply(context, args);
            }, ms || 800);
        };
    }

    function _dataTableTypeDelay ( dataTableSearchBoxElement ) {

        // Change the behaviour of datatables filter (wait until user stops typing)
        let $filterBox = dataTableSearchBoxElement;
        let previousKeyword = dataTableSearchBoxElement.val();
        let handlers = $.extend({}, $._data($filterBox[0], 'events')['keyup']); // Clone the object

        // Remove all keyup methods, we will run them later
        $filterBox.unbind();

        let stoppedTyping; // we want to capture our timer to remove it
        $filterBox.on('keyup', function () {
            let processEl = dataTableSearchBoxElement.closest('.dt-container').find('.dt-processing');
            let newKeyword = $filterBox.val().trim();
            if (previousKeyword !== newKeyword) {
                processEl.show();
            }

            // remove existing timer
            if (stoppedTyping) clearTimeout(stoppedTyping);

            // Set a timer to check if we stopped typing
            stoppedTyping = setTimeout($.proxy(function ( e ) {
                for (let i in handlers) {
                    if (handlers[i].guid && previousKeyword !== newKeyword) {
                        handlers[i].handler.apply(this, [ e ]);
                    }
                }

                previousKeyword = newKeyword;

                if (processEl.is(':visible')) {
                    processEl.hide();
                }
            }, this), 800);

            return false;
        });
    }

    function editorTextLimit (el, text) {
        const max_chars = 20000; //max characters
        const elParent = el.closest('.bot-item-answer');
        const numberChars = text.length;

        elParent.find('.invalid-feedback').remove();
        elParent.find('.tox').css({ 'border-color': '#eeeeee' });

        if (numberChars > max_chars) {
            elParent.find('.tox').css({ 'border-color': '#dc3545' });
            elParent.append(
                ' <span class="invalid-feedback d-block" role="alert">' +
                '<strong>The answer field exceeds the maximum number of (' + max_chars + ') characters.</strong>' +
                '</span>');
        }
    }

    function _wysiwygEditor ( selector, height = 200, onInput = null, onChange = null, additionalToolbars = '' ) {

        return tinymce.init({
            selector: selector,
            skin: false,
            content_css: false,
            branding: false,
            menubar: false,
            plugins: 'link autolink lists',
            toolbar: 'bold italic underline link ' + additionalToolbars,
            default_link_target: '_blank',
            height: height,
            elementpath: false,
            content_style: tinymceContentUiCss + '\n' + tinymceContentCss +
                '\nbody { margin: 10px 1rem 1px 1rem; } p {margin-block-start: 10px; margin-block-end: 10px;}',
            link_assume_external_targets: true,
            setup: function ( ed ) {
                ed.on('init', function () {
                    const text = ed.getContent({ format: 'text' });
                    editorTextLimit($(ed.targetElm), text);
                    $(ed.targetElm).addClass('mce-active');
                });

                ed.on('input', function ( e ) {
                    const text = ed.getContent({ format: 'text' });
                    editorTextLimit($(ed.targetElm), text);

                    if (onInput !== null) {
                        onInput($(ed.targetElm), ed.getContent());
                    }
                });

                ed.on('change', function ( e ) {
                    const text = ed.getContent({ format: 'text' });
                    editorTextLimit($(ed.targetElm), text);
                    if (onChange !== null) {
                        onChange($(ed.targetElm), ed.getContent());
                    }
                });

                ed.on('PastePreProcess', function (e) {
                    const div = document.createElement('div');
                    div.innerHTML = e.content;

                    const elements = div.querySelectorAll('font');
                    elements.forEach(el => {
                        // Create a new <span> element
                        const span = document.createElement('span');

                        // Move all child nodes from <font> to <span>
                        while (el.firstChild) {
                            span.appendChild(el.firstChild);
                        }

                        // Replace the <font> tag with the new <span> tag
                        el.parentNode.replaceChild(span, el);
                    });

                    e.content = div.innerHTML;
                });
            }
        })
    }

    function _submitFormButton ( e ) {
        e.preventDefault();
        let target = $(this).data('target');
        if (target) {
            $(target)[0].submit();
        }
    }

    function copyToClipBoard () {
        /* Copy the text inside the text field */
        if (!navigator.clipboard) {
            // use old commandExec() way
            $(this).select();
            document.execCommand("copy");
            $('.copy-on-click').tooltip('show');
        } else {
            navigator.clipboard.writeText($(this).val()).then(
                function () {
                    $('.copy-on-click').tooltip('show');
                });
        }

        setTimeout(function () {
            $('.copy-on-click').tooltip('hide');
        }, 1000);
    }

    return {
        init: function () {
            _initRoute($('.page_route').val());
            $('body').on('click', '.confirm-remove', _confirmRemove)
                .on('click', '.submit-form-button', _submitFormButton);

            $('.copy-on-click').tooltip({
                trigger: 'click',
                placement: 'top',
                title: "Copied to clipboard."
            }).on('click', copyToClipBoard);

            $('#logout-menuitem').on('click', function (e) {
                e.preventDefault();
                document.getElementById('logout-form').submit();
            })

            $('[ data-bs-toggle="tooltip"]').tooltip();
        },
        registerRoute: function ( route, callback ) {
            if (typeof route == 'string') {
                if (routeCallbacks[route]) routeCallbacks[route].push(callback);
                else routeCallbacks[route] = [ callback ];
            } else routeCallbacksRegex.push({ regex: route, callback: callback });
        },
        dataTableTypeDelay: _dataTableTypeDelay,
        confirmationModal: _confirmationModal,
        toastNotification: _toastNotification,
        wysiwygEditor: _wysiwygEditor,
        typeDelay: _typeDelay,
    };
})();

// making things happen
$(function () {
    _App.init();
});

// so we can import this file and then stuff things into the app namespace
// like Chatbot.whatever = (function(){ ... })();
export default _App;
